import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ComponentFactoryResolver, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { CcBaseComponent } from 'src/app/crystal-elements/cc-base.component';
import { CalculationService } from 'src/app/services/user-tools/calculation.service';

@Component({
  selector: 'app-hogo-button',
  templateUrl: './hogo-button.component.html',
  styleUrls: ['./hogo-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    TranslateService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HogoButtonComponent extends CcBaseComponent{
  @Input()
  buttonTitle: string = 'page.clearing.hogo.title';
  @Input()
  transPartKey: string = 'clearing.hogo';

  @Input()
  gasOilPricesCountLimitStr: string = 'page.clearing.hogo.gas_oil_prices__count_limit'

  constructor(cdref: ChangeDetectorRef,
                componentFactoryResolver: ComponentFactoryResolver,
                messageService: MessageService,
                protected calculationService: CalculationService,
                translateService: TranslateService) {
      super(cdref, messageService, translateService);

    }
}
